import { createAuthClient } from "better-auth/react";
import {
	inferAdditionalFields,
	organizationClient,
} from "better-auth/client/plugins";
import { ac, roles } from "./access-control";
import { env } from "./env";

export const authClient = createAuthClient({
	baseURL: env.API_URL,
	plugins: [
		organizationClient({
			ac,
			roles,
		}),
		// Extra user columns the API puts on the session (apps/api/src/auth/index.ts).
		inferAdditionalFields({
			user: {
				phone: { type: "string", required: false },
				telegramId: { type: "string", required: false },
				siteRole: { type: "string", required: false, input: false },
				locale: { type: "string", required: false },
			},
		}),
	],
});


